import script from "./CopiedButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./CopiedButton.vue?vue&type=script&setup=true&lang=ts"

import "./CopiedButton.vue?vue&type=style&index=0&id=b1d1f5f8&scoped=true&lang=css"

import exportComponent from "/Users/aleksandrvasilevic/Documents/Dev/WEB/Pets/phone-book/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1d1f5f8"]])

export default __exports__